import {
  createContext,
  FC,
  HTMLAttributes,
  ReactNode,
  useContext,
  useEffect,
} from "react";
import {
  FieldValues,
  useForm,
  UseFormProps,
  UseFormReturn,
} from "react-hook-form";

type FormControllerProps = UseFormProps & {
  children?: ReactNode | ReactNode[];
  getController?: (controller: UseFormReturn) => void;
  onSubmit?: (_value: FieldValues) => void;
  formProps?: HTMLAttributes<HTMLFormElement>;
};

const FormControllerContext = createContext<
  UseFormReturn<FieldValues, any> | undefined
>(undefined);

export const FormController: FC<FormControllerProps> = ({
  children,
  getController,
  onSubmit,
  formProps,
  ...props
}) => {
  const hookFormProps = useForm(props);

  useEffect(() => {
    getController?.(hookFormProps);
  }, [getController]);
  return (
    <FormControllerContext.Provider value={hookFormProps}>
      <form
        action="#"
        onSubmit={() => hookFormProps.handleSubmit(onSubmit || (() => {}))}
        {...formProps}
      >
        {children}
      </form>
    </FormControllerContext.Provider>
  );
};

export const useFormController = () => useContext(FormControllerContext);

export default FormController;
